//#region Agnular Imports

import { StateService } from '@uirouter/angularjs'

//#endregion

//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { Activity } from '../../models/common'
import { ColumnModel } from './../api/api.models'
import { Enums } from '../../models/common/enums'
import { GetViewColumnOptions, OpView } from '../../models/core/op-view'
import { ObjectCustomString } from '../../models/util'
import { OpBounds } from '../../models/custom/op-map-area'
import { OpDevice } from '../../models/core/op-device'
import { OpViewColumn } from '../../models/core/op-view-column'

import { CommonHelper, FilterNames } from '../../helpers/common-helper'
import { LogHelper } from '../../helpers'
import { EventsNames } from '../../helpers/events-names'
import { UserSessionService } from '../../services/user-session'
import { LocalizationHelper } from '../../helpers/localization-helper'
import { MapHelper } from '../../helpers/map-helper'

import { DeviceService } from '../../services/device'
import { GridContextMenuService } from '../../services/grid'
import { SystemService } from '../../services/system'
import { LoggerService } from './../common/common.module'

import { Api, LocalDictionaryFactory } from './../api/api.module'
import { BaseGridGridsterController, ScopeBaseGridsterGrid } from '../common/common.base.grid.gridster.controller'
import { BulkEditInitParams } from '../common/create-edit-popup/create-edit-popup.controller'
import { ButtonsOptions, GridController, GridTypes } from '../common/grid/grid.controller'
import { DetailsOptions } from './../common/details-popup/details-popup.directive'
import { ExportOptions } from '../common/export/export.directive.controller'
import { GridDetailsController } from '../common/grid-details/grid-details.directive.controller'
import { ImportOptions } from '../common/import/import.directive'
import { MapLegendItem, MapOptions } from '../common/map2/map.directive.controller'
import { IIMRAddExternalDevice, IMRAddExternalDeviceInitializedArgs, IMRAddExternalDeviceOptions } from './custom/add-external-device/add-external-device.interfaces'

export interface DevicesScope extends ScopeBaseGridsterGrid {
	deleteConfirmationOptions: {
		title: string

		onConfirmed: () => void
	}
	addExternalDeviceOptions: IMRAddExternalDeviceOptions
}

export class DevicesController extends BaseGridGridsterController {
	// Consts

	// Consts End

	// Members

	private grid: GridController<OpDevice>
	private addExternalDevice: IIMRAddExternalDevice

	// Members End

	// Ctor

	constructor(
		protected $scope: DevicesScope,
		$state: StateService,
		$timeout: ng.ITimeoutService,
		api: Api,
		private logger: LoggerService,
		localDictionary: LocalDictionaryFactory,
		protected userSession: UserSessionService,
		protected deviceService: DeviceService,
		private gridContextMenuService: GridContextMenuService,
		protected systemService: SystemService,
		referenceType: Enums.ReferenceType,
		private moduleName: Enums.SimaxModuleName
	) {
		super(
			$scope,
			$timeout,
			$state,
			userSession,
			systemService,
			api,
			localDictionary,
			null,
			GridDetailsController.getOptionsByReferenceType(Enums.ReferenceType.SerialNbr),
			Enums.SimaxModuleName[moduleName],
			referenceType,
			true
		)

		this.setConfirmationsOptions()
		this.setEvents()
		this.setMainGridOptions()
		this.setAddExternalDeviceOptions()
	}

	// Ctor End

	// Events

	private onInitialized(e: any, grid: GridController<OpDevice>): void {
		this.dataGrid = e.component
		this.grid = grid

		this.setGridId(e.tableId)
		this.onGridInit(e.tableId)
	}

	private onAdd(): void {
		this.$scope.$broadcast(EventsNames.INITIALIZE_CREATE_EDIT_POPUP, this.deviceService.getCreateEditOptions(this.userSession))
	}

	private onEdit(): void {
		if (this.grid.selectedCount === 1) {
			this.$scope.$broadcast(
				EventsNames.INITIALIZE_CREATE_EDIT_POPUP,
				this.deviceService.getCreateEditOptions(this.userSession, this.grid.selectedItemId, null, Enums.SimaxCreateEditSelectedTabType.BaseParameters, this.grid.selectedItem.idDeviceType)
			)
		} else {
			const columnCount: number = this.grid.dxGrid.columnCount()
			const columns: any = []

			for (let i = 0; i < columnCount; ++i) {
				columns.push(this.grid.dxGrid.columnOption(i))
			}

			const bulkEditInitParams: BulkEditInitParams = {
				gridColumns: columns,
				groupReferenceType: null,
				groupReferenceValue: null,
				idReferenceType: this.referenceType,
				moduleName: this.moduleName,
				section: null,
				selectedGridRows: angular.copy(this.grid.selectedGridItems),
				useBusinessObjects: true,
			}

			this.$scope.$root.$broadcast(EventsNames.INITIALIZE_BULK_EDIT_POPUP, bulkEditInitParams)
		}
	}

	private onShowDetails(e: any): void {
		const detailsOptions: DetailsOptions = this.deviceService.getDetailsOptions(this.grid.selectedItemId)
		detailsOptions.pageItemsIds = this.grid.pageItemsIds

		this.showDetails(e, detailsOptions)
	}

	private onDelete(): void {
		this.$scope.$broadcast(
			EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.popupId,
			LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__CONFIRM_DELETE, this.moduleName)
		)
	}

	private onDeleted(): void {
		this.grid.dxGrid.refresh()
	}

	private onConfirmDelete(): void {
		this.deviceService
			.deleteDevice(this.userSession.getDataProvider(), this.grid.selectedItemId)
			.then(() => {
				this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName))
			})
			.fail((error: any) => {
				LogHelper.error(DeviceService.LOG_PREFIX, error)
			})
	}

	private onAddExternalDevice(): void {
		if (this.addExternalDevice != null) {
			this.addExternalDevice.show()
		}
	}

	// Events End

	// Setup

	private getContextMenuItems(isTouchScreen: boolean = false): any[] {
		const items = this.gridContextMenuService.getContextMenuItemsByReferenceType(Enums.ReferenceType.SerialNbr, {
			idReferenceTypes: this.grid.selectedItemsIds,
			onEdit: () => this.onEdit(),
			getCorrespondingActionType: (idReferenceType: Enums.ReferenceType, args: any) => this.getCorrespondingActionType(idReferenceType, args),
		})

		return this.mergeWithDefaultItems(isTouchScreen, items)
	}

	private getGridButtonsOptions(): ButtonsOptions {
		return {
			enabled: true,

			showDetailsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.DEVICE_LIST) ? "['" + Activity[Activity.DEVICE_LIST] + "']" : null,
			deletePermissions: this.userSession.getLoggedOperator().hasPermission(Activity.DEVICE_DEL) ? "['" + Activity[Activity.DEVICE_DEL] + "']" : null,
			editPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.DEVICE_EDIT) ? "['" + Activity[Activity.DEVICE_EDIT] + "']" : null,
			addPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.DEVICE_ADD) ? "['" + Activity[Activity.DEVICE_ADD] + "']" : null,
			importPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.DEVICE_IMPORT_OP) ? "['" + Activity[Activity.DEVICE_IMPORT_OP] + "']" : null,
			exportPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.DEVICE_EXPORT_OP) ? "['" + Activity[Activity.DEVICE_EXPORT_OP] + "']" : null,
			saveColumnSettingsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP)
				? "['" + Activity[Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP] + "']"
				: null,
			addExternalDevicePermissions: this.userSession.getLoggedOperator().hasPermission(Activity.EXTERNAL_DEVICE_ADD) ? "['" + Activity[Activity.EXTERNAL_DEVICE_ADD] + "']" : null,

			onShowClick: (e: any) => this.onShowDetails(e),
			onAddClick: () => this.onAdd(),
			onAddExternalDeviceButtonClick: () => {
				this.onAddExternalDevice()
			},
			onEditClick: () => this.onEdit(),
			onDeleteClick: () => this.onDelete(),
			onShowMap: () => this.showMapDetails(),
			onShowPreview: () => this.showPreviewDetails(),
		}
	}

	private getImportOptions(): ImportOptions {
		return {
			dictionaryMethodName: 'getDeviceImportParams',
			popupName: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ImportDevices),
			requestMethodType: 'device',
			referenceType: this.referenceType,
			moduleName: this.moduleName,
			columnsReorderingDisabled: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.DeviceModuleMainGrid),
		}
	}

	private getExportOptions(): ExportOptions {
		return {
			referenceType: this.referenceType,
			pluginOptions: {
				moduleName: this.moduleName,
				popupName: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EXPORT, this.moduleName),
			},
		}
	}

	private getMainGridDataSourceParser(): any {
		return (device: OpDevice) => {
			if (device == null) {
				return null
			}

			const additionalFieldsObj: { additionalFields: { key: string; value: any }[] } = {
				additionalFields: [],
			}

			// LAT LONG COLS
			if (device.dynamicValues != null) {
				const view: OpView = this.userSession.getDataProvider().View.getActiveViewLocal(this.referenceType)

				let options: GetViewColumnOptions

				options = new GetViewColumnOptions(Enums.DataType.HELPER_ID_LOCATION)
				options.keyColumn = view.getPrimaryKeyColumn()
				options.viewColumnType = Enums.ViewColumnType.BaseHelper

				const locationColumn: OpViewColumn = view.getViewColumn(options)
				if (locationColumn != null) {
					options = new GetViewColumnOptions(Enums.DataType.LOCATION_LATITUDE)
					options.keyColumn = locationColumn
					options.viewColumnType = Enums.ViewColumnType.Standard

					const latitudeColumn: OpViewColumn = view.getViewColumn(options)

					options = new GetViewColumnOptions(Enums.DataType.LOCATION_LONGITUDE)
					options.keyColumn = locationColumn
					options.viewColumnType = Enums.ViewColumnType.Standard

					const longitudeColumn: OpViewColumn = view.getViewColumn(options)

					if (latitudeColumn != null && longitudeColumn != null) {
						const latitudeKv: any = _.find(device.dynamicValues, (dynamicValue: any) => dynamicValue.Key === latitudeColumn.name)
						const longitudeKv: any = _.find(device.dynamicValues, (dynamicValue: any) => dynamicValue.Key === longitudeColumn.name)

						additionalFieldsObj.additionalFields.push({
							key: MapHelper.LatitudeFieldName,
							value: latitudeKv == null ? null : latitudeKv.Value,
						})

						additionalFieldsObj.additionalFields.push({
							key: MapHelper.LongitudeFieldName,
							value: longitudeKv == null ? null : longitudeKv.Value,
						})
					}
				}
			}

			// MARKER TOOLTIP
			const markerFormat: string = ObjectCustomString.getCutomMarkerStringFormat(device)

			if (markerFormat != null) {
				additionalFieldsObj.additionalFields.push({
					key: MapHelper.MarkerStringFieldName,
					value: ObjectCustomString.getObjectCustomString(markerFormat, device),
				})
			}

			// MARKEK COLOR
			if (device.dataList != null && device.dataList.length > 0) {
				additionalFieldsObj.additionalFields.push({
					key: MapHelper.MarkerColorFieldName,
					value: device.dataList.getValue(Enums.DataType.HELPER_COLOR),
				})
			}

			return additionalFieldsObj
		}
	}

	private setEvents(): void {
		this.$scope.$on(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName), (event: ng.IAngularEvent, ...args: any[]) => this.onDeleted())

		this.$scope.showDetails = (e: any) => this.onShowDetails(e)
	}

	private setMainGridOptions(): void {
		$.when(
			this.userSession.getDataProvider().System.getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GRID_PARAMS, this.moduleName, {
				groupReferenceType: Enums.ReferenceType.IdDistributor,
				groupReferenceValue: this.userSession.getLoggedOperator().idDistributor,
			}),
			this.userSession.getDataProvider().System.getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__DEFAULT_GRID_PARAMS, this.moduleName, {
				groupReferenceType: Enums.ReferenceType.IdDistributor,
				groupReferenceValue: this.userSession.getLoggedOperator().idDistributor,
			})
		).then((columns: ColumnModel[], defaultColumns: ColumnModel[]) => {
			this.$scope.mainGridOptions = {
				addCustomFilters: true,
				buttonsOptions: this.getGridButtonsOptions(),
				columnsDictionary: columns,
				dataSourceParser: this.getMainGridDataSourceParser(),
				defaultColumnsDictionary: defaultColumns,
				exportMethod: 'devices',
				exportOptions: this.getExportOptions(),
				getDataSourceMethod: this.userSession.getDataProvider().Device.getDeviceFilter,
				importOptions: this.getImportOptions(),
				idReferenceType: this.referenceType,
				localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.deviceSaved,
				name: 'DevicesGrid',
				preExecuteClearFilter: this.preExecuteGridClearFilter,
				referenceId: this.referenceType,
				type: GridTypes.MAIN,

				allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.DeviceModuleMainGrid),

				contextMenuItems: (isTouchScreen: boolean = false) => this.getContextMenuItems(isTouchScreen),
				onDataReady: (data: any) => this.onDataReady(data),
				onInitialized: (e: any, grid: GridController<OpDevice>) => this.onInitialized(e, grid),
				onRowDoubleClick: (e: any) => this.onShowDetails(e),
				onSelectionChanged: (e: any) => this.onSelectionChanged(e),
				onUpdateGridsterPosition: (e: any) => this.setGridsterPosition(e),
			}
		})
	}

	private setConfirmationsOptions(): void {
		this.$scope.deleteConfirmationOptions = {
			title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETING, this.moduleName),

			onConfirmed: () => this.onConfirmDelete(),
		}
	}

	private setAddExternalDeviceOptions(): void {
		this.$scope.addExternalDeviceOptions = {
			onInitialized: (e: IMRAddExternalDeviceInitializedArgs) => {
				this.addExternalDevice = e.component
			},
			onSubmited: () => {
				this.grid.dxGrid.refresh()
			},
		}
	}

	// Setup End

	// BaseGridGridsterController Implementation

	protected onGridsterMapConfiguration(mapOptions: MapOptions): void {
		mapOptions.enableAreaSelect = true

		mapOptions.onAreaSelect = (bounds: OpBounds) => {
			MapHelper.getCoordColumnNames(this.userSession.getDataProvider(), Enums.ReferenceType.SerialNbr).then(([latColName, lonColName]: [string, string]) => {
				this.addCustomGridFilter(CommonHelper.getLonLatFilter(bounds, latColName, lonColName, FilterNames.DevicesByLocations))
			})
		}

		MapHelper.getLegendItems(this.userSession.getDataProvider(), Enums.ReferenceType.SerialNbr).then((items: MapLegendItem[]) => {
			mapOptions.legendItems = items
		})
	}

	// BaseGridGridsterController Implementation End
}
